export default __webpack_public_path__ + "static/SR India - ISO 9001 - Certificate-7d36583bb874c8e0b09a5f8960190291.pdf";